import axios from 'axios';


axios.defaults.baseURL = "https://api-hail.catnat.previmeteo.net/"
// extract data from request result, empty string is converted null
const getData = res => res.data || null;
const token = "db554ab6cf7564d26fd92bd25628076c"
const api = {

	/**
	* Set/Unset Bearer token for auth headers.
	* @param {string | null} token The new auth token or null.
	*/
	setBearerToken: token => {
		if (token) {
			axios.defaults.headers.common["Authorization"] = "Bearer 7799ec92cf506be854c27e6d4eec5e84" ;
		} else {
			axios.defaults.headers.common["Authorization"] = undefined;
		}
	},

	token: {
		validate: id => axios.get(`/token/${id}`).then(getData),
		get: ({ login, password }) => axios.post("/token", { login, password }).then(getData)
	},

	users: {
		get: id => axios.get(`/users/${id}`).then(getData)
	},

	clients: {
		getAll: () => axios.get(`/clients`).then(getData),
		get: id => axios.get(`/clients/${id}`).then(getData)
	},
	address: {
		get: () => axios.get(`https://api-adresse.data.gouv.fr/search/?q=8+bd+du+port`).then(getData),
	},
	forecast: {
		getBbox:(day, day_fcast)=>
			axios.get(`hailcast/layers/${day}/bbox?day_fcast=${day_fcast}&token=${token}`).then(getData),
		getDay: (day, day_fcast) => 
		axios.defaults.baseURL +
		`hailcast/layers/${day}?day_fcast=${day_fcast}&token=${token}`,
	},
	radar: {
		getDay: (day) => 
		axios.defaults.baseURL +
		`radar/layers/days/${day}?token=${token}`,
		getHours: (timestamp) => axios.defaults.baseURL +
		`radar/layers/hours/${timestamp}?token=${token}`,
		getQuarter: (timestamp) => axios.defaults.baseURL +
		`radar/layers/quarters/${timestamp}?token=${token}`,
		getDayValid: (day) => axios.get(`radar/layers/days/${day}?token=${token}`).then(getData),
		getHourValid: (timestamp) => axios.get(`radar/layers/hours/${timestamp}?token=${token}`).then(getData),
		getHoursDatas: (timestamp, codeISO) => axios.get(`/radar/data/hours/${timestamp}/${codeISO}`).then(getData),
		getDayDatas: (day, codeISO) => axios.get(`/radar/data/days/${day}/${codeISO}`).then(getData),

		
	}

};

export default api;

